<div class="veify-link-sent-container">
  <!-- <img src="assets/mascot/Mascot_happy_wink.svg" alt="mascot" /> -->

  <div class="verifyLinkSent-content">
    <h1 class="title">{{'email.verification.link.send.title' | translate}}</h1>
    <p class="desc" [innerHTML]="'desc.email.verification.link.send' | translate: { email: emailVerifyData.email, duration: emailVerifyData.expiredTimeTotalSeconds | formatTime : 'days' }"></p>
  </div>

  <div class="footer-action">
    <app-button [textButton]="true" [buttonName]="'label.back.to.home'" (click)="navigateBackToHome()"></app-button>
  </div>
</div>
